import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { pagedList, sortDirection } from "@/models/pagedList";
import { CustomerInfoModel } from "@/models/customerModels";
import { ImportRequest, ImportResult, SisasImportItem } from "@/models/importModels";
@Component({})
export default class imporDetail extends Vue {
  @Prop({ default: () => null })
  item: SisasImportItem;
  showDettaglioCompleto: boolean = false;
  get importRequest(): ImportRequest {
    return (this.item || ({} as SisasImportItem)).request || new ImportRequest();
  }
  get importResult(): ImportResult {
    return (this.item || ({} as SisasImportItem)).result || {} as ImportResult;
  }
}
